var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"aplicativos"}},[_c('ul',_vm._l((_vm.contents.content),function(aplicativo){return _c('li',[_c('a',{attrs:{"contents":aplicativo,"href":aplicativo.link}},[_c('SvgIcon',{attrs:{"data":_vm.icons[aplicativo.app],"original":""}})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }